export const isDev = window.location.hostname === 'localhost'

export const getRootPath = () => (isDev ? '' : `/${window.location.pathname.split('/')[1] || ''}`)

export const setLocationHref = (url: string) => {
  window.location.href = url
}
